export const ANSWER_MARKDOWN_FIELD_OPTIONS = {
  minHeight: '50px',
  placeholder: 'Enter answer text...',
};
